<div class="seo-content-container {{ component.slopingUpperEdge == 'true' ? 'withEdge' : '' }}" [ngClass]="component.background">
  <svg viewBox="0 0 200 12" class="tilt" *ngIf="component.slopingUpperEdge == 'true'">
    <path d="M 0,12 200,0 v 12 H 0 Z"></path>
  </svg>
  <div class="content" [ngClass]="component.alignment">
    <div class="info {{component.image ? '' : 'noImage'}}">
      <div class="text">
        <div class="title">
          <kion-headline-tag [title]="component.title" [titleSize]="component.titleSize"></kion-headline-tag>
        </div>
        <div class="description">
          <markdown [data]="component.content"></markdown>
        </div>
      </div>
      <div class="image" *ngIf="component.image">
        <img
          *ngIf="component.image as image "
          [lazyLoad]="image.url + '?width=540&padColor=' + imageBackground"
          [defaultImage]="image.url + '?height=50&width=50&padColor=' + imageBackground"
          errorImage="./assets/ui/shared/error/not_found_error_image.png"
          src="#"
          [alt]="image.altText"
          [title]="image.titleText || image.altText"
          width="auto" height="auto" />
      </div>
    </div>
  </div>
</div>
